export type User = {
  id: number;
  phone: string | null;
  skip_email_ask: 0 | 1;
  first_name: string;
  last_name: string;
  birth_date: number;
  zip_code: string;
  adult_family_members: number;
  child_family_members: number;
  senior_family_members: number;
  baby_supplies: number | null;
  language: string;
  food_pick_up: 0 | 1;
  pick_up_name: string | null;
  pick_up_phone: string | null;
  emergency_contact_name: string | null;
  emergency_contact_phone: string | null;
  address: string;
  second_phone: 0 | 1;
  sms_opt_in: 0 | 1;
  receive_notifications: 0 | 1;
  address_street_1: string;
  address_street_2: string;
  city: string;
  state: string;
  google_place_id: string | null;
  family_size_updated: 1;
  message_method: number;
  otp_attempts: number | null;
  otp_requests: number | null;
  otp_verified: number | null;
  otp_created: number | null;
  otp_total_attempts: number | null;
  otp_total_requests: number | null;
  magic_link_token: string | null;
  has_twilio_error: 0 | 1;
  qr_url: string;
  year_of_birth: number;
  expo_push_token: null;
  deactivated_phone: null;
  onboarding_complete: 0 | 1;
  plenti_pass: null;
  below_min_household_income: 0 | 1 | null;
  tefap_attestation_complete: 0 | 1 | null;
  tefap_expiration_date: string | null;
  needs_assistance: 0 | 1 | null;
  food_preparation: null;
  is_eligible_for_tefap: 0 | 1 | null;
  gender: string;
  relationship_status: string;
  housing: string;
  household_income: string;
  immigration_status: string;
  country_of_birth: string;
  ethnicity: string;
  education: string;
  employment: string;
  latitude: number;
  longitude: number;
  email: string;
  email_verified: number;
  skip_phone_ask: 0 | 1 | null;
  email_unsubscribed: 0 | 1 | null;
  dietary_preferences: Array<string>;
  docs: Array<string>;
  assistance_programs: Array<{
    public_assistance_program_id: number;
    participates: 0 | 1 | null;
  }>;
  last_verified: number | null;
  reverify_before: number | null;
  verified_at: number | null;
  device_expo_push_token: null;
};

export const TefapEligibility = {
  // Unfortunately these values come through the API as stored in the database, and are not self-describing.
  // See: https://github.com/PlentifulApp/plentiful-api/blob/0327876e7a87924c01ad860525eca1edaf0aa184/api/models/Visit.js#L94
  ATTESTED_AND_NOT_ELIGIBLE: 0,
  ATTESTED_AND_ELIGIBLE: 1,
  NOT_ATTESTED: null,
} as const;
